import TeacherGifCardAPI from '@/apis/business/teacher/teacher-gif-card-api.js'
import Enumeration from '@/common/enumeration.js'

export default {
  namespaced: true,
  state: {
    giftCardNumber: 0, // Số lượng thẻ học liệu của giáo viên
    listGiftCards: [], // thẻ qùa tặng của giáo viên
    usedCount: 0// số thẻ học liệu đã dùng
  },
  getters: {},
  mutations: {
    /**
     * @description Set giá trị cho listGiftCards
     * @author VHSON
     */
    setListGiftCards (state, param) {
      state.listGiftCards = param
    },
    /**
     * @description Set giá trị cho giftCardNumber
     * @author TTLONG
     */
    setGiftCardNumber (state, param) {
      state.giftCardNumber = param
    },
    /**
     * @description Set giá trị cho usedCount
     * @author TTLONG
     */
    setUsedCount (state, param) {
      state.usedCount = param
    }
  },
  actions: {

    /**
     * Lấy số lượng thẻ học liệu của giáo viên
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getNumberPractice (context) {
      return new Promise((resolve, reject) => {
        TeacherGifCardAPI.getAsync('/get-teacher-giftcard')
          .then((res) => {
            const card = res.Data.filter(item => item.GiftCardType === Enumeration.GiftCardType.UsedExerciseStore)
            if (card.length > 0) {
              context.commit('setGiftCardNumber', card[0].GiftCardNumber)
              context.commit('setUsedCount', card[0].UsedCount)
              context.commit('setListGiftCards', res.Data)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
